export const offSet = (pageNumber: number, pageSize:number) => {
  return (pageNumber - 1) * pageSize 
}